<template>
  <div class="absolute inset-x-0 top-0 z-50 w-full h-full bg-white flex flex-col items-center">
    <Logo />
    <p class="font-semibold mt-2">{{ errorMsg }}</p>
  </div>
</template>

<script>
import Logo from '@/components/shared/Logo.vue'

export default {
  data() {
    return {
      errorMsg: this.$t(`mygwf.layouts.Error.message`),
    }
  },
  components: {
    Logo,
  },
}
</script>
